<template>
  <div>
    <div>
      <pie-chart
        :library="chartOptions"
        :data="specialty"
        :colors="colors"
        :legend="true"
        height="300px"
        width="100%"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';
import AdminClient from '@/api/AdminClient';

Vue.use(Chartkick.use(Chart));

export default {
    name: 'CounselorBySpecialtyPercentage',
    data() {
      return {
        adminClient: new AdminClient(this.$http),
        selected: '',
        chartOptions: {
          legend: {
            display: true,
            labels:
            {
              fontColor: '#f5f5f5'
            }
          },

        },
        colors: [
        '#4cf2f0',
        '#77e9b8',
        '#9de093',
        '#c0d476',
        '#e0c567',
        '#e49b4d',
        '#e16e47',
        '#dc564b',
        '#d43d51',
        '#ed5d8d',
        '#f983c7',
        '#cd9ae6'
        ]
      }
    },
    asyncComputed:{
      async counselorBySpecialty() {
        const response = await this.adminClient.getCounselorSpecialty()
        if (!response || !response.results) return {}
        return response.results
      }
    },
    computed: {
      specialty() {
        if (!this.counselorBySpecialty) return {}
        let specialty = {}
        specialty = this.counselorBySpecialty[0]
         if (!specialty) return {}
        return this.capitaplize_keys_for_chart(specialty)
      }
    },
    methods: {
     capitaplize_keys_for_chart(specialty) {
        const capitalized = {}
        for (const key of Object.keys(specialty)) {
          const str = key.split('_').join(' ')
          const upper = str.replace(/^(.)|\s+(.)/g, c => c.toUpperCase());
          capitalized[upper] = specialty[key]
        }
        return capitalized
      }
    }
}
</script>
